import { render, staticRenderFns } from "./eventDragModal.vue?vue&type=template&id=2038c7a6&scoped=true&"
import script from "./eventDragModal.vue?vue&type=script&lang=js&"
export * from "./eventDragModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038c7a6",
  null
  
)

export default component.exports